import { Component, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { TablePlayerListService } from './table-player-list.service';
import { ToastrService } from "ngx-toastr";
import { PlayerListService } from '../player-list/player-list.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/shared/services/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-table-player-list',
  templateUrl: './table-player-list.component.html',
  styleUrls: ['./table-player-list.component.scss'],
  providers: [TablePlayerListService]
})
export class TablePlayerListComponent {
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;

  public transactions: Array<any> = [];
  public userId: string = '';
  public document: string = '';
  public accountId: string = '';
  public productId: string = '';

  public errorMessage: string = '';
  public passwordInsert: string = '';
  public validatingPassword: boolean = false;

  private selectedRow: any = null;
  private nextActive: boolean = false;

  @ViewChild('requestPassword') requestPassword!: ElementRef;
  @Output() transactionsLoaded = new EventEmitter<any[]>();

  private dtf = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  constructor(
    private playerListService: PlayerListService,
    private tablePlayerListService: TablePlayerListService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private authService: AuthService
  ) {
    this.getPlayers();
  }

  private formatDateTime(value: any): string {
    if (!value) return '-';
    const s = String(value);
    if (s.startsWith('0001-01-01')) return '-';
    const d = new Date(s);
    if (isNaN(d.getTime())) return '-';
    return this.dtf.format(d).replace(',', '');
  }

  public getPlayers() {
    this.playerListService
      .getUserRegistration(this.page, this.pageSize, this.userId, this.document, this.accountId, this.productId)
      .subscribe({
        next: (res: any) => {
          const items = Array.isArray(res) ? res : (res?.items ?? []);
          const total = Array.isArray(res) ? items.length : (res?.total ?? items.length);

          this.transactions = (items as any[]).map((t: any) => ({
            ...t,
            createAtView: this.formatDateTime(t.createAt),
            updateAtView: this.formatDateTime(t.updateAt),
          }));

          this.total = total;
          this.transactionsLoaded.emit(this.transactions);
        },
        error: (err) => {
          console.error(err);

          this.transactions = [];
          this.total = 0;

          this.toastr.error('Erro ao carregar listagem', 'Erro', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });

          this.transactionsLoaded.emit([]);
        }
      });
  }

  pageChange() {
    this.getPlayers();
  }

  openToggleModal(row: any, ev: MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();

    this.selectedRow = row;
    this.nextActive = !row.active;

    this.errorMessage = '';
    this.passwordInsert = '';
    this.validatingPassword = false;

    this.modalService.open(this.requestPassword, {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'sm',
    });
  }

  async pasteTotpCode(): Promise<void> {
    try {
      this.passwordInsert = (await navigator.clipboard.readText()).trim();
    } catch (err) {
      console.error('Erro ao colar token:', err);
    }
  }

  confirmToggle() {
    if (this.validatingPassword) return;

    if (!this.selectedRow?.document) {
      this.errorMessage = 'Documento inválido.';
      return;
    }

    if (!this.passwordInsert?.trim()) {
      this.errorMessage = 'Informe o token.';
      return;
    }

    this.validatingPassword = true;
    this.errorMessage = '';

    this.playerListService
      .setUserRegistrationActive(this.selectedRow.document, this.nextActive, this.passwordInsert.trim())
      .pipe(finalize(() => (this.validatingPassword = false)))
      .subscribe({
        next: () => {
          this.modalService.dismissAll();
          this.getPlayers();
          this.toastr.success('Status alterado com sucesso!', 'Sucesso', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = err?.error?.mensagem || 'Falha ao alterar status.';
        },
      });
  }
}